import { createReducer, on } from '@ngrx/store';
import { loadConfig, loadConfigError } from './config.actions';
import { Config, ResStatus } from 'src/app/models/config.interface';

export interface ConfigState {
  config: Config;
  status: ResStatus;
  error: string;
  errorMessage?: string;
}
const initialState: ConfigState = {
  config: {
    client_config: { test: 'test' },
    config: { test: 'test' },
    instructions: { test: 'test' },
    media: { test: {} },
    questions: [],
    statements: { test: {} },
    translations: { test: {} }
  },
  status: 'pending',
  error: ''
};

export const configReducer = createReducer(
  initialState,
  on(loadConfig, (state, { config }) => {
    if (config) {
      return {
        ...state,
        config: {
          ...state.config,
          client_config: config.client_config,
          config: config.config,
          instructions: config.instructions,
          media: config.media,
          questions: config.questions,
          statements: config.statements,
          translations: config.translations
        }
      };
    }
    return { ...state };
  }),

  on(loadConfigError, (state, { error }) => ({
    ...state,
    status: <ResStatus>'error',
    errorMessage: error
  }))
);
